<template>
  <div>
    <p
      v-show="locationUrlCode == 1"
      style="text-align: center; font-weight: bold"
    >
      拔河网隐私政策
    </p>
    <p
      v-show="locationUrlCode == 2"
      style="text-align: center; font-weight: bold"
    >
      拔河网用户协议
    </p>

    <div v-html="yszcContent"></div>
  </div>
</template>
<script>
// 不再导入axios，使用Vue.prototype.$axios
import { baseUrl } from '../../../api/config.js'
export default {
  name: "AppDownload",
  components: {},
  data() {
    return {
      yszcContent: null,
      locationUrlCode: "",
    };
  },
  created() {
    // 确保路由参数正确获取
    this.locationUrlCode = this.$route.query.code || "";
    console.log("locationUrl", this.locationUrlCode);
    this.geiYszc();
  },
  methods: {
    geiYszc() {
      console.log("this.locationUrlCode.code", this.locationUrlCode);
      let params = {
        code:
          this.locationUrlCode == 1
            ? "privacyPolicy"
            : this.locationUrlCode == 2
            ? "userAgreemt"
            : "",
      };
      // alert("接收的code:" + this.locationUrlCode);
      // 当前请求地址是正式地址
      // 测试：http://101.42.248.138:8012/
      // 正式：http://114.55.107.49:8012/
      // 使用this.$axios而不是直接axios，保持配置一致
      this.$axios
        .post(
            baseUrl + '/u058-business/mall/v1/mallad/article/getArticleByCode',
            params
        )
        .then((res) => {
          if (res.data.code == 0) {
            this.yszcContent = decodeURIComponent(res.data.dataInfo.content);
            // console.log("yszcContent", this.yszcContent);
          }
        });
      // });
      //直接跳转app下载页面
    },
  },
};
</script>
<style type="text/css">
body,
div,
span,
i {
  font-size: 100%;
  box-sizing: border-box;
}
p {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/policy/index.vue